import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import icFlagEn from '@/assets/icons/ic_flag_en.svg';
import icFlagFr from '@/assets/icons/ic_flag_fr.svg';
import icFlagDe from '@/assets/icons/ic_flag_de.svg';
import icFlagEs from '@/assets/icons/ic_flag_es.svg';
import icFlagPt from '@/assets/icons/ic_flag_pt.svg';

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();

  const languages = [
    { code: 'en', name: t('languages.english'), flag: icFlagEn },
    { code: 'fr', name: t('languages.french'), flag: icFlagFr },
    { code: 'de', name: t('languages.german'), flag: icFlagDe },
    { code: 'es', name: t('languages.spanish'), flag: icFlagEs },
    { code: 'pt', name: t('languages.portuguese'), flag: icFlagPt },
  ];

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem('userLanguage', value);
  };

  return (
    <Select
      value={i18n.language}
      onValueChange={handleLanguageChange}
    >
      <SelectTrigger className="w-[100px]">
        <SelectValue placeholder={t('languages.select')} />
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <div className="flex items-center gap-2">
              <img src={lang.flag} alt={lang.name} width="20px" height="16px" className="w-5 h-4 object-contain" />
              <span>{lang.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;